import React from 'react';
import { Grid, Skeleton, Card } from '@mui/material';

const YourOpenRoleWidgetShimmer = () => {
  return (
    <Grid
      container
      data-testid='section_loadingSkeleton'
      direction='column'
      rowSpacing={3}
    >
      <Grid item>
        <Skeleton
          variant='rectangular'
          width='40%'
          height={40}
          animation='wave'
          sx={{ mb: 1, ml: 2, bgcolor: (theme) => theme.palette.neutral?.main }}
        />
      </Grid>
      <Grid
        item
        container
        direction='row'
        rowSpacing={3}
        xs={12}
        sm={6}
        md={4}
        lg={3}
      >
        {Array.from({ length: 4 }, (_, index) => (
          <Card
            key={index}
            sx={{ mt: 2, ml: 2, height: '270px', width: '420px' }}
          >
            <Grid item container direction='column' rowSpacing={3}>
              <Grid item>
                <Skeleton
                  variant='rectangular'
                  width='40%'
                  height={28}
                  animation='wave'
                  sx={{
                    mb: 1,
                    ml: 2,
                    mt: 2,
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
                <Skeleton
                  variant='rectangular'
                  width='10%'
                  height={24}
                  animation='wave'
                  sx={{
                    mb: 0.3,
                    ml: 2,
                    mt: 1,
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
                <Skeleton
                  variant='rectangular'
                  width='40%'
                  height={24}
                  animation='wave'
                  sx={{
                    mb: 1,
                    ml: 2,
                    mt: 0.5,
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
                <Skeleton
                  variant='rectangular'
                  width='92%'
                  height={124}
                  animation='wave'
                  sx={{
                    ml: 2,
                    mt: 2,
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
              </Grid>
            </Grid>
          </Card>
        ))}
      </Grid>
    </Grid>
  );
};

export default YourOpenRoleWidgetShimmer;
